import { useContext } from '@nuxtjs/composition-api'
import { CLASSIFIED_FORM_NS } from '~/store/modules/shared/classifieds/form/state'
import { FieldOptions } from '~/store/modules/shared/classifieds/form/actions'
import { ClientValidator, FieldChange } from '~/models/form/types'
import { ADD_CLIENT_VALIDATOR } from '~/store/modules/shared/classifieds/form/mutation-types'

export function useDefaultForm() {
  const { store } = useContext()
  const valueChanged = (name: string, value: any, options?: FieldOptions) => {
    return store.dispatch(`${CLASSIFIED_FORM_NS}/fieldChanged`, {
      field: {
        name,
        value,
        options
      }
    })
  }
  function valuesChanged(fields: FieldChange[]) {
    return store.dispatch(`${CLASSIFIED_FORM_NS}/fieldsChanged`, fields)
  }

  function addClientValidator(validator: ClientValidator) {
    return store.commit(
      `${CLASSIFIED_FORM_NS}/${ADD_CLIENT_VALIDATOR}`,
      validator
    )
  }

  return { valueChanged, valuesChanged, addClientValidator }
}
